var newsList = {
	noResults: "No se encontraron resultados",
	readMore: "Leer más",
	estimatedReadingTime: "~{minutes} min de lectura"
};
var es = {
	newsList: newsList
};

export { es as default, newsList };
